/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {

  GetOpenBatchesList : state => {
    return state.openBatchesList
  },
  GetBatchStatesList : state => {
    return state.batchStatesList
  },
  GetMyHoldList : state => {
    return state.myHoldList
  },
  GetMySupReviewList : state => {
    return state.mySupReviewList
  },
  GetIncident : state =>{
    return state.incident
  },
  GetIncidentClaims : state => {
    return state.incidentClaims
  },
  GetIncidentSupplements : state => {
    return state.incidentSupplements
  }
  
}

export default getters
